import { useAccount } from 'wagmi';

import { useDataChainId } from './useDataChainStore';

export const useIsWrongNetwork = (): boolean => {
  const { chainId, isConnected } = useAccount();
  const desiredChain = useDataChainId();

  return isConnected && chainId !== desiredChain;
};
